module.exports = __webpack_public_path__ + "static/media/ic_next.b0f42068.svg";